import {
  BulkTypeDeliveryPeriod,
  DeliveryPeriodsByShop,
  DeliveryPeriodsByType,
  DeliveryPeriodType,
} from '../../../models';

export const hasBulkToSelect = (
  bulkDelivery: DeliveryPeriodsByType<BulkTypeDeliveryPeriod> | undefined,
) => {
  if (!bulkDelivery) {
    return false;
  }
  return !!bulkDelivery.deliveryPeriods?.length;
};

export const getSelectedBulkDate = (
  bulkDelivery: DeliveryPeriodsByType<BulkTypeDeliveryPeriod> | undefined,
  selectedBulk: BulkTypeDeliveryPeriod | null,
) => {
  if (!bulkDelivery) {
    return null;
  }

  const canSelectDate =
    hasBulkToSelect(bulkDelivery) &&
    selectedBulk &&
    !!(bulkDelivery?.deliveryPeriods as BulkTypeDeliveryPeriod[]).find(
      (item) => item.from === selectedBulk.from && item.to === selectedBulk.to,
    );

  if (canSelectDate) {
    return selectedBulk;
  }

  if (hasBulkToSelect(bulkDelivery)) {
    return (bulkDelivery.deliveryPeriods as BulkTypeDeliveryPeriod[])[0];
  }

  return null;
};

export const updateShopsWithBulkDeliveryPeriod = (
  deliveryPeriodsByShop: DeliveryPeriodsByShop,
  selectedBulk: BulkTypeDeliveryPeriod | null,
): DeliveryPeriodsByShop => {
  return Object.keys(deliveryPeriodsByShop).reduce((result, key) => {
    const shopDelivery = deliveryPeriodsByShop[key];
    const bulkDelivery = shopDelivery[DeliveryPeriodType.Bulk];
    const selectedBulkDate = getSelectedBulkDate(bulkDelivery, selectedBulk);
    return {
      ...result,
      [key]: {
        ...shopDelivery,
        [DeliveryPeriodType.Bulk]: {
          ...bulkDelivery,
          selectedDeliveryPeriod: selectedBulkDate,
        },
        currentDeliveryPeriodType: hasBulkToSelect(bulkDelivery)
          ? DeliveryPeriodType.Bulk
          : DeliveryPeriodType.Now,
      },
    } as DeliveryPeriodsByShop;
  }, {} as DeliveryPeriodsByShop);
};
